export default __webpack_public_path__ + "static/person-f33a322d8424f389392eb9c4b5142d76.jpg";